<template>
  <Grid
    class="r-chip q-py-xs cursor-pointer"
    :class="[
      active
        ? 'q-pl-sm q-pr-md text-body-3 text-white-1 bg-graph-certain text-capitalize'
        : 'bg-white-3 text-body-1 text-grey3 q-px-md q-py-sm'
    ]"
    gaf="column"
    gap="var(--r-space-xs)"
    align-items="center"
    @click.native="$emit('click')"
  >
    <DoneIcon v-if="active" dense class="done-icon" />
    <slot />
  </Grid>
</template>

<script>
import DoneIcon from '@/ui/icons/DoneIcon'

export default {
  components: {
    DoneIcon
  },

  props: {
    active: Boolean
  }
}
</script>

<style lang="scss" scoped>
.r-chip {
  border-radius: var(--r-space-md);
  white-space: nowrap;

  ::v-deep .done-icon {
    width: var(--r-icon-size);

    path {
      fill: var(--r-white-1);
    }
  }
}
</style>
